var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import styled from "styled-components";
import { RouterLink } from "@irati/ui/src/Link";
import label4 from "@irati/ui/src/Link/css/label4";
import { LatoBold } from "@irati/ui/src/global/fonts";
export default styled(RouterLink).attrs({
    styled: false
})(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: block;\n  padding: 10px 15px;\n  margin: 0 10px;\n  text-decoration: none;\n  cursor: pointer;\n  background-color: ", ";\n  color: ", ";\n\n  &:hover,\n  &:focus,\n  &:active {\n    color: ", ";\n    background-color: ", ";\n    text-decoration: none;\n  }\n  ", "\n  ", "\n"], ["\n  display: block;\n  padding: 10px 15px;\n  margin: 0 10px;\n  text-decoration: none;\n  cursor: pointer;\n  background-color: ",
    ";\n  color: ", ";\n\n  &:hover,\n  &:focus,\n  &:active {\n    color: ", ";\n    background-color: ", ";\n    text-decoration: none;\n  }\n  ", "\n  ", "\n"])), function (_a) {
    var isCurrent = _a.isCurrent, theme = _a.theme;
    var _b = theme.colors.greys, lightest = _b.lightest, white = _b.white;
    return isCurrent ? lightest : white;
}, function (_a) {
    var color = _a.color, theme = _a.theme;
    return color || theme.colors.greys.black;
}, function (_a) {
    var color = _a.color, theme = _a.theme;
    return color || theme.colors.greys.black;
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.greys.graphGrey;
}, label4, LatoBold);
var templateObject_1;
